import React, { useEffect, useState } from "react";
import "./css/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const countriesInfo = [
  {
    scholorshipTypes: [
      {
        type: "Scholarships Available",
        overview: `<p>In Germany, DAAD offers scholarships to international students through partnered institutions. There are two types of scholarships available: Monetary and Non- Monetary scholarships Under Monetary scholarship, if you get a full scholarship then you will be awarded an amount equivalent to your tuition fee for all the semester. If you get a partial scholarship then you must take help from other organizations that provide funds to international students with excellent academic background.</p>
        
        <p>The other kind of scholarship, which is non- monetary means you get access to free lectures, scientific conferences and workshops.</p>`,
        details: [],
      },
      {
        type: "Scholarship Foundations",
        overview: ``,
        // overview:
        //   "If you are a student from a European country then, you can use an exchange program called ERASMUS. This student exchange program allows you to stay exempt from tuition fees to the host universities. Under this, you get a scholarship installment each month.",
        details: [
          {
            title: "Party affiliated scholarships:",
            longDescription:
              "In Germany, more and more political parties are coming forward in order to finance international students. If you are someone who is socially active with powerful political views then these intuitions are right for you to approach for financial aid or scholarships.",
          },
          {
            title: "Corporate scholarships:",
            longDescription:
              "Many corporate also fund talented student grants for studying at universities.",
          },
          {
            title: "Social/Religious Institutions:",
            longDescription:
              "Many religious institutions such as churches offer scholarships for students. Criteria for these scholarships besides good grades are financial hardship. If you are facing any financial hardship then approaching these institutions is the right choice.",
          },
        ],
      },
    ],
    countryName: "GERMANY",
    countryShort: "Germany",

    // overview: `These are the documents required for the visa for studying abroad
    // in the United Kingdom`,
  },
  {
    scholorshipTypes: [
      {
        type: "Scholarships",
        details: [
          {
            title:
              "Scholarships for international students who wish to pursue their studies in the USA are competitive.",
            longDescription:
              "Many universities in the USA grant scholarships to international students. Search for scholarship programs on the internet. IEFA.org provides scholarships, financial aid, and grant information to students pursuing studies abroad. Your own home country can also provide you with scholarships for studying abroad.",
          },
          {
            title:
              "In addition, there is a need blind admission policy in the USA",
            longDescription:
              "under which a college or university will admit students regardless of their capability to pay. So, for these students who cannot afford the tuition fee, the universities will offer those scholarships and financial aid to make up the difference.",
          },
        ],
      },
    ],
    countryName: "U.S.A.",
    countryShort: "U.S.A.",
    overview: "",
  },
  {
    scholorshipTypes: [
      {
        type: "Governmental Scholarships",
        overview:
          "The British government runs two large scholarship schemes for international students:",
        details: [
          {
            title: "Chevening Scholarships",
            longDescription:
              "These scholarships are awarded to students with excellent academic background and skills. They are awarded by the foreign and commonwealth office. The students who wish to pursue one year master’s degree at the United Kingdom university are eligible for this scholarship.",
          },
          {
            title: "Commonwealth Scholarships",
            longDescription:
              "Commonwealth Scholarships is for international students regulated jointly by 53 countries (former British colonies). Commonwealth Scholarships are funded by the Department for International Development. Commonwealth scholarships are awarded for one year master’s degree programs or equivalent and doctoral degree programs that last for 3-4 years.",
          },
        ],
      },
      {
        type: "United Kingdom University Scholarships",
        overview:
          "Here is a list of scholarships provided to international students by universities in United Kingdom:",
        details: [
          {
            title: "Gates Cambridge Scholarship",
            longDescription:
              "The University of Cambridge has an attractive opportunity for international students. The Gates Scholarship program offers financial assistance to capable foreign applicants seeking to attend a full-time postgraduate course at this University.",
          },
          {
            title: "Rhodes House Scholarships",
            longDescription: ` <p>This scheme awards scholarships to postgraduate students aiming to study at the University of Oxford. The Scholarship covers all university tuition fees and two economy class airfares.</p>
            
            <p>United Kingdom scholarships are generally harder to acquire for international students. Students who wish to apply for the scholarship must meet certain requirements such as their residency, age, and education. Also, the university sets age limits due to which students between 18 and 28 of age are eligible to apply. And as for ages above 28, it varies from institution to institution. You are only eligible to apply for this scholarship if you’re a citizen of one of the following countries:</p>
            
            <p>Australia, Bermuda, Canada, China, Germany, Hong Kong, India, Israel, Jamaica & the Commonwealth Caribbean, Kenya, Malaysia, New Zealand, Pakistan, Southern Africa (including South Africa, Botswana, Lesotho, Malawi, Namibia and Swaziland), Syria, Jordan, Lebanon and Palestine, United Arab Emirates, United States, West Africa ( lately added), Zambia and Zimbabwe.</p>`,
          },
          {
            title: "MBA Skoll Scholarships",
            longDescription:
              " <>These Scholarships are awarded by the Said School Business of the University of Oxford. The scholarship is applicable for Master’s degree programs. The MBA Skoll Scholarship covers all tuition fees and essential living expenses.",
          },
          {
            title: "Edinburgh Global Research Scholarships",
            longDescription: `<p>The University of Edinburgh endows 30 scholarships to international students with commendable academic excellence, who are willing to pursue a PhD course at the above mentioned university. This scholarship will cover only partial tuition fees.</p>
            
            <p>These are a few of the scholarships that are granted to international students. The list of scholarships in the United Kingdom is endless and gives immense opportunities to international students.</p>`,
          },
        ],
      },
    ],
    countryName: "UNITED KINGDOM",
    countryShort: "UK",
    overview: "",
  },
  {
    scholorshipTypes: [
      {
        type: "Canadian Government Scholarships",
        details: [
          {
            title: "Banting Postdoctoral Fellowships",
            longDescription:
              "These scholarships and fellowships are offered to international students undertaking postgraduate study within the natural and social sciences or health research.",
          },
          {
            title: "Canada Graduate Scholarships - Master&#39;s Program",
            longDescription:
              "These are the Scholarships for Canadian students enrolled in a master&#39;s degree or PhD at a university in Canada.",
          },
          {
            title: "IDRC Research Awards",
            longDescription:
              "These scholarships are for students from developing countries who wish to pursue a master&#39;s or doctoral-level research degree at a recognized Canadian university.",
          },
          {
            title: "NSERC Postgraduate scholarships",
            longDescription:
              "These scholarships are available to outstanding students pursuing study in the natural sciences or engineering at an accredited Canadian university.",
          },
          {
            title: "Vanier Canada Graduate Scholarships Program",
            longDescription:
              "These scholarships are available to doctoral students internationally, to study in Canada at a participating university.",
          },
        ],
      },
      {
        type: "Non-governmental Scholarships",
        details: [
          {
            title: "Anne Vallee Ecological Fund",
            longDescription:
              "These Scholarships are for international students pursuing animal research at the doctoral level at a recognized Canadian university in Québec or British Columbia.",
          },
          {
            title: "Canada Memorial Scholarship",
            longDescription:
              "These are full scholarships available for British postgraduate students to study at any recognized Canadian higher education provider, covering tuition, airfares, accommodation and more.",
          },
          {
            title: "Trudeau Scholarships and Fellowships",
            longDescription:
              "The Trudeau Foundation offers a variety of scholarships, fellowships and mentorships to international students at the doctoral level pursuing study in Canada at selected institutions or Universities.",
          },
        ],
      },
      {
        type: "University Specific Scholarships",
        details: [
          {
            title: "Carleton University Awards for International Students",
            longDescription:
              "These are the Scholarships to study in Canada at Carleton University. It is open to all graduate students, who are automatically considered for the awards upon application.",
          },
          {
            title: "Concordia University International Undergraduate Awards",
            longDescription:
              "These consist of various scholarships for international students to study at Concordia University in Montréal. It is open to all the international students at undergraduate level.",
          },
          {
            title: "Dalhousie University Scholarships",
            longDescription:
              "These Scholarships are for current and prospective international and domestic students of all levels studying at Dalhousie University in Halifax.",
          },
          {
            title:
              "Fairleigh Dickinson Scholarships for International Students",
            longDescription:
              "These Scholarships are for international students of all levels pursuing study at Fairleigh Dickinson University in Vancouver.",
          },
          {
            title: "HEC Montréal Scholarships",
            longDescription:
              "These are various merit- and need-based scholarships for international students which include mobility scholarships for international students as well.",
          },
          {
            title:
              "International Student Scholarships at Humber College Canada",
            longDescription:
              "These are various scholarships for international students at undergraduate level to study at Humber College in Toronto. There are plenty more university scholarships available for study abroad Canada.",
          },
        ],
      },
    ],
    countryName: "CANADA",
    countryShort: "Canada",
    overview: "",
  },
  {
    scholorshipTypes: [
      {
        type: "Scholarships",
        overview: "",
        details: [
          {
            title:
              "Academic Excellence Scholarships - Canadian University of Dubai",
            longDescription: `<p>The Canadian University of Dubai is offering a 30?e reduction to both new and returning students across all undergraduate and graduate programs. In some cases, this fee reduction can be combined with applicable scholarships to result in a fee reduction of up to 60%.</p>
            
            <p>Degree level: Academic Excellence Scholarships - Canadian University of Dubai are available for study at the Bachelor&#39;s level at the Canadian University of Dubai.</p>`,
          },
          {
            title:
              "International Students Scholarship at University of New South Wales, Dubai Campus",
            longDescription:
              "International Students Scholarship at the University of New South Wales, Dubai Campus, is available for International Students. The scholarship allows students to pursue Undergraduate and Bachelor level programs in Aircraft Maintenance Engineering at the University of South Wales. Scholarships are available for undergraduate (BSc) studies.",
          },
          {
            title:
              "Cass Business School Executive MBA Scholarships in Dubai Campus",
            longDescription:
              "Cass Business School Executive MBA Scholarships in Dubai Campus are now available for International Students. The scholarship allows you to pursue a Master&#39;s level program(s) in the field taught at Cass Business School.",
          },
          {
            title: "Academic Scholarship at University of Wollongong, Dubai",
            longDescription:
              "International students can apply for a postgraduate academic excellence scholarship at the University of Wollongong Dubai. Scholarships are available for postgraduate study at the University of Wollongong in Dubai (UOWD), which is one of the UAE&#39;s oldest and most prestigious universities. The UAE Ministry of Higher Education and Scientific Research has accredited all UOWD academic programs, and the University of Wollongong in Australia is registered with the Tertiary Education Quality and Standards Agency (TEQSA), Australia&#39;s national regulator of the higher education sector. Applicants for a postgraduate degree must have earned a Bachelor&#39;s degree (or its equivalent) from an accredited institution of higher learning. All instruction at UOWD is in English, and students must demonstrate adequate English language proficiency in order to enroll in a program at the university.",
          },
        ],
      },
      {
        type: "Government Scholarships in Dubai",
        overview: `<ul>
        <li><p class="sc-list-title2">Types of Government Scholarships</p></li>
        <li><p class="sc-list-title2">The Benjamin A. Gilman International Scholarships</li>
        <li><p class="sc-list-title2">The David L. Boren Scholarships</p></li>
        </ul>
<br />
        <p>Students must be Pell Grant recipients and academically accomplished to be eligible for the Benjamin A. Gilman International Scholarships. These highly competitive scholarships award up to $5,000.</p>
        
        <p>The David L. Boren Scholarships are also very beneficial. The federal government requires a large number of highly trained individuals who are fluent in security-sensitive languages such as Arabic and foreign cultures such as Islamic studies. These are extremely competitive and heavily advertised. This scholarship is only available to the best undergraduates and graduates. Following graduation, recipients are required to work for the Department of Defense or Homeland Security. Students who are seriously considering long-term careers in the federal government are given priority. Scholarships of up to $26,000 are available.</p>`,
        details: [],
      },
    ],
    countryName: "U.A.E",
    countryShort: "U.A.E",
    overview: "",
  },
  {
    scholorshipTypes: [
      {
        type: "Scholarships",
        overview: "",
        details: [
          {
            title: "Australian Awards",
            longDescription:
              "This program brings together the scholarships by the Department of Foreign Affairs (DFAT), the Department of Education and the Australian Centre for International Agricultural Research (ACIAR).",
          },
          {
            title: "Canada Graduate Scholarships - Master's Program",
            longDescription:
              "These are the Scholarships for Canadian students enrolled in a master's degree or Ph.D. at a university in Canada.",
          },
          {
            title: "Destination Australia",
            longDescription:
              "This is a new program by the Government of Australia for both international and domestic students. Under this, over 1000 scholarships will be awarded to students for studying in regional locations of Australia.",
          },
          {
            title: "Australian Government Research Training Program",
            longDescription:
              "Under this program, students both domestic and international receive funding for research doctoral courses and research master’s degrees.",
          },
          {
            title: "Australia APEC Women in Research Fellowship",
            longDescription:
              "This program is for women from APEC countries for research opportunities in collaboration with Australian education and research institutions.",
          },
          {
            title: "Provider Scholarships",
            longDescription:
              "Australian education providers regularly provide scholarships to international students on a merit basis.",
          },
        ],
      },
    ],
    countryName: "AUSTRALIA",
    countryShort: "Australia",
    overview: "",
  },
];

export default function ScholarShip(props) {
  console.log(props.selectedTab, "line 319");
  const [selectedCountryInfo, setSelectedCountryInfo] = useState({
    scholorshipTypes: [
      {
        type: "Scholarships Available",
        overview: `<p>In Germany, DAAD offers scholarships to international students through partnered institutions. There are two types of scholarships available: Monetary and Non- Monetary scholarships Under Monetary scholarship, if you get a full scholarship then you will be awarded an amount equivalent to your tuition fee for all the semester. If you get a partial scholarship then you must take help from other organizations that provide funds to international students with excellent academic background.</p>
        
        <p>The other kind of scholarship, which is non- monetary means you get access to free lectures, scientific conferences and workshops.</p>`,
        details: [],
      },
      {
        type: "Scholarship Foundations",
        overview:
          "If you are a student from a European country then, you can use an exchange program called ERASMUS. This student exchange program allows you to stay exempt from tuition fees to the host universities. Under this, you get a scholarship installment each month.",
        details: [
          {
            title: "Party affiliated scholarships:",
            longDescription:
              "In Germany, more and more political parties are coming forward in order to finance international students. If you are someone who is socially active with powerful political views then these intuitions are right for you to approach for financial aid or scholarships.",
          },
          {
            title: "Corporate scholarships:",
            longDescription:
              "Many corporate also fund talented student grants for studying at universities.",
          },
          {
            title: "Social/Religious Institutions:",
            longDescription:
              "Many religious institutions such as churches offer scholarships for students. Criteria for these scholarships besides good grades are financial hardship. If you are facing any financial hardship then approaching these institutions is the right choice.",
          },
        ],
      },
    ],
    countryName: "GERMANY",
    countryShort: "Germany",
    overview: "",
  });

  const [scholorShipDetailsToRender, setScholorShipDetailsToRender] = useState(
    []
  );
  const [activeTab, setActiveTab] = useState("");
  const handleTabClick = (tabSelected) => {
    const scholorshipDetailsIndex =
      selectedCountryInfo.scholorshipTypes.findIndex((info) => {
        return info.type === tabSelected;
      });

    setScholorShipDetailsToRender(
      selectedCountryInfo.scholorshipTypes[scholorshipDetailsIndex]
    );
    setActiveTab(tabSelected);
  };

  useEffect(() => {
    if (props.selectedTab) {
      const countryInfo = countriesInfo.findIndex((info) => {
        return info.countryName === props.selectedTab;
      });

      setSelectedCountryInfo(countriesInfo[countryInfo]);
    }
  }, [props.selectedTab]);

  useEffect(() => {
    if (
      selectedCountryInfo?.scholorshipTypes &&
      selectedCountryInfo?.scholorshipTypes.length > 0
    ) {
      setActiveTab(selectedCountryInfo?.scholorshipTypes[0].type);
      setScholorShipDetailsToRender(selectedCountryInfo?.scholorshipTypes[0]);
    }
  }, [selectedCountryInfo]);

  useEffect(() => {}, [activeTab]);

  useEffect(() => {}, [scholorShipDetailsToRender]);

  const renderTabs = selectedCountryInfo.scholorshipTypes.map((item, index) => {
    return (
      <div
        key={index}
        className={
          activeTab === item.type
            ? "col-lg-2 col-md-3 col-sm-4 col-6 cb-wrapper active" +
              (index % 2 === 0 ? " wow bounceInRight" : " wow bounceInLeft")
            : "col-lg-2 col-md-3 col-sm-4 col-6 cb-wrapper" +
              (index % 2 === 0 ? " wow bounceInRight" : " wow bounceInLeft")
        }
        data-wow-duration="2s"
        onClick={() => handleTabClick(item.type)}
      >
        <div className="country-btn1 ">
          <div className="country-title1">{item.type}</div>
        </div>
      </div>
    );
  });

  const RenderScholorshipDetails = (props) => {
    const renderElaboratedDetails = props.detailsToRender.map((detail) => {
      return (
        <li
          key={Math.random()}
          className="wow fadeIn"
          data-wow-duration="3s"
          data-wow-delay="1s"
        >
          <div className="sc-icon">
            <img
              src={require("../../assets/scholarshipicon.svg").default}
              alt="scholorship"
            />
          </div>
          <div className="sc-text">
            <div className="sc-list-title">{detail.title}</div>
            <div className="sc-list-desc">
              <div
                dangerouslySetInnerHTML={{
                  __html: detail.scholorshipDetail,
                }}
              ></div>
            </div>
          </div>
        </li>
      );
    });
    return <>{renderElaboratedDetails}</>;
  };

  return (
    <section className="bg_container_scholer">
      <div className="res_scholer_container">
        <div className="country-tab scholar-tab">
          <div className="scholer_title_container">
            <p className="title_text">SCHOLARSHIPS</p>
            <p className="sub_title_text">
              {props.selectedTab === "AUSTRALIA"
                ? `There is a vast variety of scholarships available for international students.`
                : ""}
              {props.selectedTab === "CANADA"
                ? `There are three types of scholarships available
for study abroad Canada`
                : ""}

              {props.selectedTab === "UNITED KINGDOM"
                ? `Types of Scholarships available for international students in the United Kingdom`
                : ""}
              {props.selectedTab === "U.A.E"
                ? `In Dubai, you can study on fully or partially funded scholarships. Every year, the government of Dubai and universities in Dubai award scholarships to international students and local residents, here is a compiled list of some of the best PhD Scholarships in Dubai, Masters Scholarships in Dubai, and undergraduate level scholarships.
`
                : ""}
            </p>
          </div>
          <div className="container-lg">
            <div className=" scrollable1 justify-content-center">
              {renderTabs}
            </div>
            <div className="card_width_container">
              <div
                className="row scholar-tab-content wow fadeIn"
                data-wow-duration="2s"
              >
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div
                        className="sc-tile wow fadeIn"
                        data-wow-duration="3s"
                        data-wow-delay="0.5s"
                        dangerouslySetInnerHTML={{
                          __html: selectedCountryInfo?.overview
                            ? selectedCountryInfo?.overview
                            : null,
                        }}
                      ></div>
                      <div className="sc-body">
                        <ul className="list-unstyled sc-list">
                          {scholorShipDetailsToRender?.type ? (
                            <div>
                              <div
                                className="sc-tile wow fadeIn"
                                data-wow-duration="3s"
                                data-wow-delay="0.5s"
                                dangerouslySetInnerHTML={{
                                  __html: scholorShipDetailsToRender?.overview
                                    ? scholorShipDetailsToRender?.overview
                                    : null,
                                }}
                              ></div>
                              {scholorShipDetailsToRender?.details.length >
                              0 ? (
                                <RenderScholorshipDetails
                                  detailsToRender={
                                    scholorShipDetailsToRender?.details
                                  }
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          ) : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
